import { getData } from "./api"
import { setLocalStorage } from "./localstorage";

export const getBmdCities = async () => {
    try {
        const res = await getData("/bmd-cities");
        setLocalStorage("bmdCities", res.data)
    } catch (error) {
        console.log(error)
    }
}